import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24EmojiG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M12 2.5c5.238 0 9.5 4.261 9.5 9.5s-4.262 9.5-9.5 9.5-9.5-4.262-9.5-9.5S6.762 2.5 12 2.5M12 4c-4.411 0-8 3.588-8 8 0 4.411 3.589 8 8 8s8-3.589 8-8c0-4.412-3.589-8-8-8"
      }), /*#__PURE__*/jsx("path", {
        d: "M10.636 10.416a.994.994 0 1 1-1.988 0 .994.994 0 0 1 1.988 0m4.716 0a.994.994 0 1 1-1.988 0 .994.994 0 0 1 1.988 0M12 16.573c-1.876 0-3.571-1.126-4.216-2.803a.751.751 0 0 1 1.401-.538c.423 1.101 1.554 1.841 2.815 1.841s2.392-.74 2.815-1.84a.75.75 0 0 1 .97-.432c.386.15.579.583.431.97-.645 1.676-2.34 2.802-4.216 2.802"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24EmojiG$1 = Svg24EmojiG;

export { Svg24EmojiG$1 as default };
